// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__Ofqsa","loading":"Loading_loading__3SgGS"};